// ein Versuch das mal ohne große Persistenz zu machen...
mp.slider = {
    slideRunning: false,

    init: function () {
        $('#mpOfferImage').on('click', function () {
            $('#mpSliderModal1')
                .modal('show')
                .find('.mpSliderElement[data-lightbox="' + $(this).attr('href') + '"]').trigger('click');
            return false;
        });
        $('.mpInlineLightboxWrapper .mpSliderElement').on('click', function () {
            $('#mpSliderModal1')
                .modal('show')
                .find('.mpSliderElement[data-lightbox="' + $(this).data('fullsize') + '"]').trigger('click');
            return false;
        });

        $('#mpSliderModal1').on('hidden.bs.modal', function () {
            $('#mpSliderModal1 .mpLightboxVideo').html('');
        })

        // INFO: hover für die Offerdetails bleibt
        $(document).on('mouseenter touchstart prevNext', '.mpInlineLightboxWrapper .mpSliderElement', mp.slider.updateInlineLightbox);
        // INFO: statt click ginge auch mouseenter für "hover", aber das fühlt sich extrem unruhig an
        $(document).on('click touchstart prevNext', '.mpLightboxWrapper .mpSliderElement', mp.slider.updateLightbox);

        $(document).on('click', '.mpLightboxControl .mpSliderUp', mp.slider.slideUp)
        $(document).on('click', '.mpLightboxControl .mpSliderDown', mp.slider.slideDown)
        $(document).on('click', '.mpLightboxControl .mpSliderLeft', mp.slider.slideLeft)
        $(document).on('click', '.mpLightboxControl .mpSliderRight', mp.slider.slideRight)

        $(document).on('click', '.mpLightboxControl .mpSliderLeftUp', function (ev) {
            ev.stopPropagation();
            $(this).find('span:visible').trigger('click');
        })
        $(document).on('click', '.mpLightboxControl .mpSliderRightDown', function (ev) {
            ev.stopPropagation();
            $(this).find('span:visible').trigger('click');
        })

        // im großen Lightbox-Content
        $(document).on('click', '.mpLightbox .mpSliderLeftWrap', function (ev) {
            ev.stopPropagation();
            $(this).parents('.mpLightboxWrapper').find('.mpLightboxControl .mpSliderLeftUp span:visible').trigger('click');
        })
        $(document).on('click', '.mpLightbox .mpSliderRightWrap', function (ev) {
            ev.stopPropagation();
            $(this).parents('.mpLightboxWrapper').find('.mpLightboxControl .mpSliderRightDown span:visible').trigger('click');
        })

        // Pfeiltasten zum Blättern
        $('#mpSliderModal1').on('keydown', function (ev) {
            if (ev.which === 37 || ev.which === 38) {
                $(this).find('.mpLightboxControl .mpSliderLeftUp span:visible').trigger('click');
            } else if (ev.which === 39 || ev.which === 40) {
                $(this).find('.mpLightboxControl .mpSliderRightDown span:visible').trigger('click');
            }
        });

        // Swipe-Navigation
        $(document).on('swipeleft', '.mpSliderElementsWrapper', function () {
            $(this).parents('.mpLightboxControl').find('.mpSliderRightDown span:visible').trigger('click');
        });
        $(document).on('swiperight', '.mpSliderElementsWrapper', function () {
            $(this).parents('.mpLightboxControl').find('.mpSliderLeftUp span:visible').trigger('click');
        });
        $(document).on('swipeleft', '.mpLightbox', function () {
            $(this).parents('.mpLightboxWrapper').find('.mpLightboxControl .mpSliderRightDown span:visible').trigger('click');
        });
        $(document).on('swiperight', '.mpLightbox', function () {
            $(this).parents('.mpLightboxWrapper').find('.mpLightboxControl .mpSliderLeftUp span:visible').trigger('click');
        });

    },

    updateInlineLightbox: function () {
        var ref = $(this);
        $(ref.data('target')).attr('href', ref.data('fullsize'));
        $(ref.data('target') + ' img').attr('srcset', '').attr('src', ref.data('lightbox'));
        ref.siblings().removeClass('active');
        ref.addClass('active');
    },

    updateLightbox: function () {
        var ref = $(this);
        var wrapper = ref.parents('.mpLightboxWrapper');

        if (ref.data('videoplatform') === 'youtube') {
            wrapper.find('.mpLightboxImage').hide();
            wrapper.find('.mpLightboxVideo').html('<iframe src="https://www.youtube-nocookie.com/embed/' + ref.data('videoid') + '" style="border:0" allowfullscreen></iframe>').show();
        } else if (ref.data('videoplatform') === 'vimeo') {
            wrapper.find('.mpLightboxImage').hide();
            wrapper.find('.mpLightboxVideo').html('<iframe src="https://player.vimeo.com/video/' + ref.data('videoid') + '?dnt=1" style="border:0" allowfullscreen></iframe>').show();
        } else if (ref.data('videoplatform') === 'gm24') {
            wrapper.find('.mpLightboxImage').hide();
            wrapper.find('.mpLightboxVideo').html('<iframe src="https://gm24-video.de/index.php?id=' + ref.data('videoid') + '" style="border:0" allowfullscreen></iframe>').show();
        } else {
            wrapper.find('.mpLightboxVideo').html('').hide();
            wrapper.find('.mpLightboxImage').show().find('img').attr('src', ref.data('lightbox'));
        }

        ref.siblings().removeClass('active');
        ref.addClass('active');
    },

    selectPrev: function (ref) {
        if (ref.find('.mpSliderElement.active').prev().length === 0) {
            mp.slider.selectNext(ref);
        } else {
            ref.find('.mpSliderElement.active').prev().trigger('prevNext');
        }
    },

    selectNext: function (ref) {
        if (ref.find('.mpSliderElement.active').next().length === 0) {
            mp.slider.selectPrev(ref);
        } else {
            ref.find('.mpSliderElement.active').next().trigger('prevNext');
        }
    },

    slideUp: function (ev) {
        ev.stopPropagation();
        if (mp.slider.slideRunning === false) {
            mp.slider.slideRunning = true;
            var ref = $(this).parents('.mpLightboxControl').find('.mpSliderElements');
            ref.prepend(ref.find('.mpSliderElement').last());
            ref.css('top', parseInt(ref.find('.mpSliderElement').first().outerHeight(true)) * -1);
            mp.slider.selectPrev(ref);
            ref.animate({
                'top': 0
            }, function () {
                mp.slider.slideRunning = false;
            });
        }
    },
    slideDown: function (ev) {
        ev.stopPropagation();
        if (mp.slider.slideRunning === false) {
            mp.slider.slideRunning = true;
            var ref = $(this).parents('.mpLightboxControl').find('.mpSliderElements');
            mp.slider.selectNext(ref);
            ref.animate({
                'top': parseInt(ref.find('.mpSliderElement').first().outerHeight(true)) * -1
            }, function () {
                ref.append(ref.find('.mpSliderElement').first());
                ref.css('top', 0);
                mp.slider.slideRunning = false;
            });
        }
    },
    slideRight: function (ev) {
        ev.stopPropagation();
        if (mp.slider.slideRunning === false) {
            mp.slider.slideRunning = true;
            var ref = $(this).parents('.mpLightboxControl').find('.mpSliderElements');
            mp.slider.selectNext(ref);
            ref.animate({
                'left': parseInt(ref.find('.mpSliderElement').first().outerWidth(true)) * -1
            }, function () {
                ref.append(ref.find('.mpSliderElement').first());
                ref.css('left', 0);
                mp.slider.slideRunning = false;
            });
        }
    },
    slideLeft: function (ev) {
        ev.stopPropagation();
        if (mp.slider.slideRunning === false) {
            mp.slider.slideRunning = true;
            var ref = $(this).parents('.mpLightboxControl').find('.mpSliderElements');
            ref.prepend(ref.find('.mpSliderElement').last());
            ref.css('left', parseInt(ref.find('.mpSliderElement').first().outerWidth(true)) * -1);
            mp.slider.selectPrev(ref);
            ref.animate({
                'left': 0
            }, function () {
                mp.slider.slideRunning = false;
            });
        }
    }

};

$(document).ready(function () {
    if ($('#mpOfferImage').length === 1 || $('.mpInlineLightboxWrapper').length > 0 || $('.mpLightboxWrapper').length > 0) {
        mp.slider.init();
    }
});
